module.exports = __webpack_public_path__ + "static/metal-f4d9c8be3514dd19956908113c424abf.jpg";